import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Plus, X, Settings2, ExternalLink } from "lucide-react";
import { toast } from "sonner";
import ContactChannelManagerModal from "@/components/repairs/ContactChannelManagerModal";

/** Iter 161 — Gestión de los desplegables de la ficha de reparación (antes con "Gestionar" junto al campo). */
export default function RepairDropdownsCard({ data, save, disabled }) {
  const [backup, setBackup] = useState(data.backup_status_catalog || []);
  const [newBackup, setNewBackup] = useState("");
  const [channels, setChannels] = useState(data.contact_channel_catalog || []);
  const [showChannels, setShowChannels] = useState(false);
  useEffect(() => {
    setBackup(data.backup_status_catalog || []);
    setChannels(data.contact_channel_catalog || []);
  }, [data.backup_status_catalog, data.contact_channel_catalog]);

  const addBackup = async () => {
    const v = newBackup.trim();
    if (!v) return;
    if (backup.includes(v)) { toast.info("Ya existe"); return; }
    const next = [...backup, v];
    setBackup(next); setNewBackup("");
    await save({ backup_status_catalog: next });
  };
  const removeBackup = async (it) => {
    if (!window.confirm(`¿Quitar "${it}" de Copia de seguridad?`)) return;
    const next = backup.filter((b) => b !== it);
    setBackup(next);
    await save({ backup_status_catalog: next });
  };

  return (
    <div className="ds-card" data-testid="repair-dropdowns-card">
      <div className="px-4 py-3 border-b border-[#E5E5E0]">
        <div className="font-display font-bold text-sm">Desplegables de la ficha de reparación</div>
        <p className="text-[11px] text-[#525252] mt-0.5">Opciones de los selectores que ven los técnicos en Reparaciones. La ficha ya no muestra botones de gestión.</p>
      </div>
      <div className="p-4 grid grid-cols-1 md:grid-cols-2 gap-5">
        <div data-testid="backup-status-manager">
          <div className="font-mono text-[10px] uppercase tracking-widest text-[#525252] mb-2">Copia de seguridad</div>
          <div className="flex flex-wrap gap-1.5 mb-2">
            {backup.map((it) => (
              <span key={it} className="inline-flex items-center gap-1 px-2 py-0.5 bg-[#F7F7F4] border border-[#E5E5E0] text-xs" data-testid={`backup-chip-${it}`}>
                {it}
                {!disabled && (
                  <button type="button" onClick={() => removeBackup(it)} className="hover:text-red-600" aria-label={`Quitar ${it}`}><X size={11} /></button>
                )}
              </span>
            ))}
            {backup.length === 0 && <span className="text-xs text-[#525252]">Sin opciones.</span>}
          </div>
          {!disabled && (
            <div className="flex gap-1">
              <input value={newBackup} onChange={(e) => setNewBackup(e.target.value)} onKeyDown={(e) => e.key === "Enter" && (e.preventDefault(), addBackup())}
                placeholder="Añadir opción" data-testid="backup-status-new"
                className="flex-1 ds-card px-2 py-1 text-xs rounded-none focus:border-[#6E8B3D] outline-none" />
              <button type="button" onClick={addBackup} data-testid="backup-status-add" className="px-2 border border-[#111110] hover:bg-[#111110] hover:text-white"><Plus size={12} /></button>
            </div>
          )}
        </div>
        <div data-testid="contact-channel-manager-card">
          <div className="flex items-center justify-between mb-2">
            <div className="font-mono text-[10px] uppercase tracking-widest text-[#525252]">Contacto con cliente</div>
            {!disabled && (
              <button type="button" onClick={() => setShowChannels(true)} data-testid="contact-channel-manage"
                className="inline-flex items-center gap-1 text-[10px] font-mono uppercase tracking-wider border border-[#111110] px-2 py-1 hover:bg-[#111110] hover:text-white">
                <Settings2 size={11} /> Gestionar opciones
              </button>
            )}
          </div>
          <div className="flex flex-wrap gap-1.5">
            {channels.filter((c) => c.active).map((c) => (
              <span key={c.id} className="px-2 py-0.5 bg-[#F7F7F4] border border-[#E5E5E0] text-xs">{c.name}</span>
            ))}
            {channels.filter((c) => !c.active).map((c) => (
              <span key={c.id} className="px-2 py-0.5 border border-dashed border-[#E5E5E0] text-xs text-[#8A8A82]" title="Inactivo">{c.name}</span>
            ))}
            {channels.length === 0 && <span className="text-xs text-[#525252]">Sin canales.</span>}
          </div>
          <p className="text-[11px] text-[#525252] mt-4 inline-flex items-center gap-1">
            Las <b>Secciones por estado</b> se gestionan en <Link to="/settings?tab=catalog" className="underline inline-flex items-center gap-0.5">Configuración → Otros catálogos <ExternalLink size={10} /></Link>.
          </p>
        </div>
      </div>
      {showChannels && (
        <ContactChannelManagerModal
          initialList={channels}
          onClose={() => setShowChannels(false)}
          onSaved={(next) => { setChannels(next); setShowChannels(false); }}
        />
      )}
    </div>
  );
}
